import styled from 'styled-components';
import { Text, Bold } from 'styles/elements/text';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { ColumnDiv } from 'styles/elements/div';

const ConfirmDetails = styled(ColumnDiv)``;

const DetailField = styled.div`
  margin-bottom: 1.9em;
`;

const Label = styled(Text)`
  margin: 1em 0 0;
`;

const EditButton = styled(SecondaryButton)`
  width: 135px
  height: 30px;
  border-radius: 12px;
  padding: 0;
  border-color: ${props => props.theme.buttonPrimaryBackgroundColor};
  margin-top: 0.2em;
`;

const UpdateButton = styled(EditButton)`
  color: white;
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
  margin-top: 0.6em;
`;

const ConfirmBold = styled(Bold)`
  word-break: break-all;
  word-break: break-word;
`;

ConfirmDetails.DetailField = DetailField;
ConfirmDetails.Text = Text;
ConfirmDetails.Bold = ConfirmBold;
ConfirmDetails.Label = Label;
ConfirmDetails.EditButton = EditButton;
ConfirmDetails.UpdateButton = UpdateButton;

export default ConfirmDetails;
